export default __webpack_public_path__ + "static/media/male.2482fa03.jfif";